import { AppState } from 'reducers'

export const root = (state: AppState) => state.states

export const cms = (state: AppState) => state.cms

export default root
